var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("w-tabs", {
                    staticClass: "tabs",
                    attrs: { value: _vm.tab, tabs: _vm.tabs },
                    on: {
                      input: function ($event) {
                        return _vm.setTab($event)
                      },
                    },
                  }),
                  _c("w-spacer"),
                  _vm.tab == 0
                    ? _c("w-select", {
                        attrs: { items: _vm.filterItems },
                        model: {
                          value: _vm.rewardedFilter,
                          callback: function ($$v) {
                            _vm.rewardedFilter = $$v
                          },
                          expression: "rewardedFilter",
                        },
                      })
                    : _c("w-select", {
                        attrs: { items: _vm.inviteFilterItems },
                        model: {
                          value: _vm.inviteStatusFilter,
                          callback: function ($$v) {
                            _vm.inviteStatusFilter = $$v
                          },
                          expression: "inviteStatusFilter",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: {
                  "flex-grow": "1",
                  height: "calc(100vh - 185px)",
                },
                attrs: {
                  items: _vm.tab == 0 ? _vm.referrals : _vm.invites,
                  columns: _vm.tab == 0 ? _vm.columns : _vm.inviteColumns,
                  "order-column": _vm.orderColumn,
                  "order-direction": _vm.orderDirection,
                },
                on: {
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                  "item-clicked": function ($event) {
                    return _vm.onItemClicked($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                [
                  _c("w-select", {
                    attrs: { items: _vm.limits, up: true },
                    model: {
                      value: _vm.limit,
                      callback: function ($$v) {
                        _vm.limit = $$v
                      },
                      expression: "limit",
                    },
                  }),
                  _c(
                    "w-col",
                    {
                      staticClass: "amountShown",
                      attrs: { xs: "6", md: "3", lg: "1" },
                    },
                    [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.showTotalRecordsText) + " "),
                      ]),
                    ]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6", lg: "4" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c("w-spacer"),
                          _c("w-pagination", {
                            attrs: {
                              value: _vm.page,
                              "max-shown-pages": 5,
                              "total-pages": _vm.pageCount,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setPage($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.selected != null, "escape-close": "" },
          on: {
            input: function ($event) {
              _vm.selected = null
            },
          },
        },
        [
          _vm.selected
            ? _c(
                "w-card",
                { staticClass: "reward-card" },
                [
                  _c("w-card-title", [_vm._v("Referral belonen")]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "div",
                        { staticClass: "referral-flow" },
                        [
                          _c(
                            "div",
                            { staticClass: "flow-party" },
                            [
                              _c("span", { staticClass: "flow-label" }, [
                                _vm._v("Aanbrenger"),
                              ]),
                              _c(
                                "w-link",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToCompany(
                                        _vm.selected.referrerCompanyId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selected.referrerCompanyName ||
                                          "#" + _vm.selected.referrerCompanyId
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("w-fa", {
                            staticClass: "flow-arrow",
                            attrs: { icon: "arrow-right" },
                          }),
                          _c(
                            "div",
                            { staticClass: "flow-party" },
                            [
                              _c("span", { staticClass: "flow-label" }, [
                                _vm._v("Aangebracht account"),
                              ]),
                              _c(
                                "w-link",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToCompany(
                                        _vm.selected.referredCompanyId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selected.referredCompanyName ||
                                          "#" + _vm.selected.referredCompanyId
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "flow-meta" }, [
                        _vm._v(
                          " Aangebracht op " +
                            _vm._s(_vm.formatDate(_vm.selected.dateCreated)) +
                            " · code " +
                            _vm._s(_vm.selected.code) +
                            " "
                        ),
                      ]),
                      _c("w-divider"),
                      _c("w-switch", {
                        staticClass: "reward-switch",
                        attrs: { label: "Beloond", space: "" },
                        model: {
                          value: _vm.rewarded,
                          callback: function ($$v) {
                            _vm.rewarded = $$v
                          },
                          expression: "rewarded",
                        },
                      }),
                      _vm.selected.rewardedAt
                        ? _c("p", { staticClass: "flow-meta" }, [
                            _vm._v(
                              " Beloond op " +
                                _vm._s(
                                  _vm.formatDate(_vm.selected.rewardedAt)
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c("w-input", {
                        attrs: { label: "Notitie (intern)", fancy: "" },
                        model: {
                          value: _vm.note,
                          callback: function ($$v) {
                            _vm.note = $$v
                          },
                          expression: "note",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              _vm.selected = null
                            },
                          },
                        },
                        [_vm._v(" Annuleren ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { loading: _vm.saving },
                          on: {
                            click: function ($event) {
                              return _vm.saveReward()
                            },
                          },
                        },
                        [_vm._v(" Opslaan ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }